const Conditional = ({
    condition,
    children,
}: {
    condition: boolean;
    children: JSX.Element | JSX.Element[];
}) => {
    if (condition)
        return (
            <>
                <>{children}</>
            </>
        );
    return <></>;
};
export default Conditional;
